__turbopack_context__.v({
  "accordionSlideOverwrite": "parentPortalDialog-module-scss-module__xtNyVq__accordionSlideOverwrite",
  "content": "parentPortalDialog-module-scss-module__xtNyVq__content",
  "description": "parentPortalDialog-module-scss-module__xtNyVq__description",
  "fadeIn": "parentPortalDialog-module-scss-module__xtNyVq__fadeIn",
  "fadeOut": "parentPortalDialog-module-scss-module__xtNyVq__fadeOut",
  "form": "parentPortalDialog-module-scss-module__xtNyVq__form",
  "formControl": "parentPortalDialog-module-scss-module__xtNyVq__formControl",
  "header": "parentPortalDialog-module-scss-module__xtNyVq__header",
  "image": "parentPortalDialog-module-scss-module__xtNyVq__image",
  "scaleIn": "parentPortalDialog-module-scss-module__xtNyVq__scaleIn",
  "scaleOut": "parentPortalDialog-module-scss-module__xtNyVq__scaleOut",
  "submitButton": "parentPortalDialog-module-scss-module__xtNyVq__submitButton",
  "textField": "parentPortalDialog-module-scss-module__xtNyVq__textField",
  "title": "parentPortalDialog-module-scss-module__xtNyVq__title",
  "zoomIn": "parentPortalDialog-module-scss-module__xtNyVq__zoomIn",
  "zoomOut": "parentPortalDialog-module-scss-module__xtNyVq__zoomOut",
});
